import { DefaultButton } from "./DefaultButton";
import { StyledIconButtonWrapper } from "./StyledIconButtonWrapper";

export const IconButton = StyledIconButtonWrapper(DefaultButton);
